export default "__VITE_ASSET__91d39a88__"